/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { FormContainer } from "../../../Components/Forms/FormContainer/FormContainer"
import { MonetaryInput } from "../../../Components/Forms/MonetaryInput/MonetaryInput"
import AppLayout from "../../../Components/Layout/Layout"
import PageTitle from "../../../Components/PageTitle/PageTitle"
import { Col, Row } from "reactstrap"
import { Fieldset } from "../../../Components/Fieldset/Fieldset"
import { Table, TableContainer, Td, Th } from "../../../Components/Table/Table"
import { IBuscaPropostaDto, IDadosParcelaProposta, IModulosDto, IParcelaProposta, IPropostaDto, ISimuladorDto } from "../../../Dtos/Comercial/Simulador/SimuladorDto"
import { Checkbox } from "../../../Components/Forms/Checkbox/Checkbox"
import { IToastOpcoes, Toast } from "../../../Components/Toast/Toast"
import ApiService from "../../../Config/ApiConfig"
import { DecimalInput } from "../../../Components/Forms/DecimalInput/DecimalInput"
import { InputNumber } from "../../../Components/Forms/InputNumber/InputNumber"
import { ButtonPrimary } from "../../../Components/Forms/SaveButton/SaveButton"
import LoadingPage from "../../../Components/Loading/Loading"
import { useNavigate, useParams } from "react-router-dom"
import { InputData } from "../../../Components/Forms/InputData/InputData"
import { FormField } from "../../../Components/Forms/FormField/FormField"
import { Label } from "../../../Components/Forms/Label/Label"
import { Input } from "../../../Components/Forms/Input/Input"
import styled from "styled-components"
import dayjs from "dayjs"

export const SimuladorPage = () => {
    const { sd43id, sd432id, copiaid } = useParams()
    const navigate = useNavigate()

    const [data, setData] = useState<ISimuladorDto>({} as ISimuladorDto)
    const [dataProposta, setDataProposta] = useState<IPropostaDto>({} as IPropostaDto)
    const [sd11s, setSd11s] = useState<Array<IModulosDto>>([])
    const [parcelas, setParcelas] = useState<Array<IParcelaProposta>>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [toastOpcoes, setToastOpcoes] = useState<IToastOpcoes>({ type: "info", visible: false, mensagem: "" })
    const [edicao, setEdicao] = useState<boolean>(false)
    const [allSelect, setAllSelect] = useState<boolean>(false)
    const [dadosParcelas, setDadosParcelas] = useState<IDadosParcelaProposta>({} as IDadosParcelaProposta)

    useEffect(() => {
        async function checkApi() {
            try {
                const apiService = new ApiService();

                const response = await apiService.get<boolean>("/auth/temAcesso", { params: { tarefa: "Simulador de Preços" } })

                if (!response) {
                    navigate("/home");
                }
            } catch (error) {
                navigate("/home");
            }
        }

        checkApi();
    }, []);

    useEffect(() => {
        setEdicao(sd432id != null)
    }, [sd432id])

    useEffect(() => {
        buscarModulos().then(() => {
            if (sd432id != null) buscarProposta(sd432id)
            if (copiaid != null) buscarProposta(copiaid)
        })

    }, [])


    const buscarModulos = async () => {
        try {
            setLoading(true)

            const apiService = new ApiService();

            const modulos = await apiService.get<Array<IModulosDto>>("/simuladorController/buscarModulos")
            setSd11s(modulos)
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao buscar modulos! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const buscarProposta = async (id: string) => {
        try {
            setLoading(true)

            const apiService = new ApiService();

            const calculo = await apiService.get<IBuscaPropostaDto>("/sd43Controller/buscarPropostaPeloId", { params: { sd432id: id } })
            setData(calculo.calcularDto)

            if (calculo.calcularDto.modulos != null && calculo.calcularDto.modulos.length > 0) {
                setSd11s(prev => prev.map(sd11 => {
                    const modu = calculo.calcularDto.modulos?.find(modulo => modulo.sd11id === sd11.sd11id);
                    return modu != null ? modu : sd11;
                }))
            }

            setDataProposta(calculo)
            setParcelas(calculo.parcelas)
            setDadosParcelas({ 
                numParcelas: calculo.sd432numparcelas,
                valorEntrada: calculo.sd432entrada,
                dataInicio: ""
            })
            

            if (copiaid != null) {
                setEdicao(false)
            }

        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao buscar modulos! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const closeToast = () => {
        setToastOpcoes({ type: "info", visible: false, mensagem: "" })
    }

    const calcularParcelas = async () => {
        try {
            setLoading(true)
            
            const apiService = new ApiService();

            const calculo = await apiService.post<Array<IParcelaProposta>>("/sd43Controller/calcularParcelarProprosta", {
                valorTotal: dataProposta.sd432valortotal ?? 0,
                ...dadosParcelas
            })
            
            setParcelas(calculo)

        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao calcular parcelas! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const selectModulo = (sd11id: number) => {
        setSd11s((prevModulos) =>
            prevModulos.map((modulo) =>
                modulo.sd11id === sd11id ? { ...modulo, selected: !modulo.selected } : modulo
            )
        );
    };

    const handleChangeLicencas = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setData(prev => ({
            ...prev,
            licencas: {
                ...prev.licencas,
                [name]: value
            }
        }));
    }

    const handleChangeValores = (name: string, value: number) => {

        setData(prev => ({
            ...prev,
            valores: {
                ...prev.valores,
                [name]: value
            }
        }));
    }

    const handleChangeSampalm = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setData(prev => ({
            ...prev,
            sampalm: {
                ...prev.sampalm,
                [name]: value
            }
        }));
    }

    const handleChangeData = (value: string, nome: string) => {
        setDataProposta(prev => ({ ...prev, [nome]: value }))
    }

    const handleChangeProposta = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setDataProposta(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleCahngeValoresProposta = (name: string, value: number) => {
        setDataProposta(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleCahngeDadosParcela = (name: string, value: any) => {
        setDadosParcelas(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const selectedAll = (value: boolean) => {
        setAllSelect(value);

        // Atualiza corretamente a lista sd11s
        const newModulos = sd11s.map((modulo) => ({
            ...modulo,
            selected: value, // Define explicitamente com base no parâmetro passado
        }));

        setSd11s(newModulos);
    };

    const btnSalvar = async () => {
        try {
            setLoading(true)
            const dados: ISimuladorDto = {
                ...data,
                modulos: sd11s
            }
            
            const proposta = {
                sd432entrada: dadosParcelas.valorEntrada,
                sd432numparcelas: dadosParcelas.numParcelas,
                dadosProposta: dados,
                parcelas: parcelas,
                sd43id: sd43id,
                ...dataProposta
            }

            const apiService = new ApiService();
            await apiService.post<ISimuladorDto>("/sd43Controller/salvarProposta", proposta)

            navigate("/prospeccao/" + sd43id)
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao salvar! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }
    const btnSimular = async () => {
        try {
            setLoading(true)
            const dados: ISimuladorDto = {
                ...data,
                modulos: sd11s
            }
            const apiService = new ApiService();
            const retorno = await apiService.post<ISimuladorDto>("/simuladorController/calcular", dados)

            setData({
                licencas: retorno.licencas,
                sampalm: retorno.sampalm,
                valores: retorno.valores,
                modulos: retorno.modulos
            })
            setSd11s(retorno.modulos)
        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao calcular simulação! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }

    }

    if (loading) {
        return (
            <LoadingPage />
        )
    }

    return (
        <AppLayout>
            <Toast
                isVisible={toastOpcoes.visible}
                message={toastOpcoes.mensagem}
                onClose={closeToast}
                type={toastOpcoes.type}
            />
            <PageTitle title="Simulador de preço" />
            <FormContainer>
                {
                    (sd43id != null || sd432id != null) && (
                        <>
                            <Fieldset legend="Implantação">
                                <Row>
                                    <Col md="2">
                                        <InputData
                                            name="sd432dtinicio"
                                            initialValue={dataProposta.sd432dtinicio ?? ""}
                                            label="Inicio"
                                            onChange={(value) => handleChangeData(value, "sd432dtinicio")}
                                            disabled={edicao}
                                        />
                                    </Col>
                                    <Col md="2">
                                        <InputData
                                            name="sd432dtfinal"
                                            initialValue={dataProposta.sd432dtfinal ?? ""}
                                            label="Final"
                                            onChange={(value) => handleChangeData(value, "sd432dtfinal")}
                                            disabled={edicao}
                                        />
                                    </Col>
                                    <Col md="8">
                                        <FormField >
                                            <Label>Condição de pagamento</Label>
                                            <Input
                                                type="text"
                                                name="sd432condicaopagamento"
                                                value={dataProposta.sd432condicaopagamento ?? ""}
                                                onChange={handleChangeProposta}
                                                disabled={edicao}
                                            />
                                        </FormField>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="4">
                                        <FormField>
                                            <Label>Valor da Hora tecnica</Label>
                                            <MonetaryInput value={dataProposta.sd432valorhora ?? 0} onChange={(value) => handleCahngeValoresProposta("sd432valorhora", value)} disabled={edicao} />
                                        </FormField>
                                    </Col>
                                    <Col md="4">
                                        <FormField >
                                            <Label>Total de horas</Label>
                                            <Input
                                                type="text"
                                                name="sd432totalhora"
                                                value={dataProposta.sd432totalhora ?? 0}
                                                onChange={handleChangeProposta}
                                                validation="numbers"
                                                disabled={edicao}
                                            />
                                        </FormField>
                                    </Col>
                                    <Col md="4">
                                        <FormField >
                                            <Label>Valor Total</Label>
                                            <MonetaryInput value={dataProposta.sd432valortotal ?? 0} onChange={(value) => handleCahngeValoresProposta("sd432valortotal", value)} disabled={edicao} />
                                        </FormField>
                                    </Col>
                                </Row>
                            </Fieldset>
                            <Fieldset legend="Parcelas" marginTop="15px">
                                <Row>
                                    <Col md="4">
                                        <FormField >
                                            <Label>Entrada</Label>
                                            <MonetaryInput value={dadosParcelas.valorEntrada ?? 0} onChange={(value)=>handleCahngeDadosParcela("valorEntrada",value)} disabled={edicao} />
                                        </FormField>
                                    </Col>
                                    <Col md="4">
                                        <FormField >
                                            <Label>Número de parcelas</Label>
                                            <Input
                                                type="text"
                                                name="parcelas"
                                                value={dadosParcelas.numParcelas}
                                                onChange={(value) => handleCahngeDadosParcela("numParcelas",Number(value.target.value))}
                                                validation="numbers"
                                                disabled={edicao}
                                            />
                                        </FormField>
                                    </Col>
                                    <Col md="2">
                                        <InputData
                                            name="primeira"
                                            initialValue={dadosParcelas.dataInicio ?? ""}
                                            label="Primeira parcela"
                                            onChange={(value) => handleCahngeDadosParcela("dataInicio",value)}
                                            disabled={edicao}
                                        />
                                    </Col>
                                    <Col md="2">
                                        {
                                            sd432id == null && <ButtonPrimary onClick={calcularParcelas} style={{ marginTop: 25 }} disabled={sd432id != null}>
                                                Calcular Parcelas
                                            </ButtonPrimary>
                                        }
                                    </Col>
                                </Row>
                                <ScrollableTableContainer>
                                    <TableContainer>
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <Th>#</Th>
                                                    <Th>Data</Th>
                                                    <Th>Valor</Th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    parcelas.map((parcela,index) => (
                                                        <tr>
                                                            <Td>{index + 1}</Td>
                                                            <Td>{dayjs(parcela.data).format("DD/MM/YYYY")}</Td>
                                                            <Td>{new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL'}).format(parcela.valor)}</Td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </TableContainer>
                                </ScrollableTableContainer>
                            </Fieldset>
                        </>
                    )
                }
                <Row style={{ marginTop: "15px" }}>
                    <Col md="6">
                        <Fieldset legend="Licenças">
                            <Row>
                                <Col>Opções</Col>
                                <Col>Locação (10%)</Col>
                                <Col>Aquisição (7%)</Col>
                            </Row>
                            <Row>
                                <Col>Modulos</Col>
                                <Col><InputNumber name="moduloLocacao" value={data?.licencas?.moduloLocacao ?? 0} onChange={handleChangeLicencas} disabled={edicao} /></Col>
                                <Col><InputNumber name="moduloAquisicao" value={data?.licencas?.moduloAquisicao ?? 0} onChange={handleChangeLicencas} disabled={edicao} /></Col>
                            </Row>
                            <Row>
                                <Col>Rec. Humanos</Col>
                                <Col><InputNumber name="rhLocacao" value={data?.licencas?.rhLocacao ?? 0} onChange={handleChangeLicencas} disabled={edicao} /></Col>
                                <Col><InputNumber name="rhAquisicao" value={data?.licencas?.rhAquisicao ?? 0} onChange={handleChangeLicencas} disabled={edicao} /></Col>
                            </Row>
                            <Row>
                                <Col>Ponto de Venda</Col>
                                <Col><InputNumber name="pdvLocacao" value={data?.licencas?.pdvLocacao ?? 0} onChange={handleChangeLicencas} disabled={edicao} /></Col>
                                <Col><InputNumber name="pdvAquisicao" value={data?.licencas?.pdvAquisicao ?? 0} onChange={handleChangeLicencas} disabled={edicao} /></Col>
                            </Row>
                            <Row>
                                <Col>Total</Col>
                                <Col><InputNumber value={data?.licencas?.totalLocacao ?? 0} disabled /></Col>
                                <Col><InputNumber value={data?.licencas?.totalAquisicao ?? 0} disabled /></Col>
                            </Row>
                        </Fieldset>
                    </Col>
                    <Col md="6">
                        <Fieldset legend="Valores">
                            <Row>
                                <Col>Descrição</Col>
                                <Col>Multitec</Col>
                                <Col>Representante</Col>
                                <Col>Cliente</Col>
                            </Row>
                            <Row>
                                <Col>Desconto (%)</Col>
                                <Col><DecimalInput disabled={edicao} value={data.valores?.descontoMultitec ?? 0} onChange={(value) => handleChangeValores("descontoMultitec", value)} /></Col>
                                <Col><DecimalInput disabled={edicao} value={data.valores?.descontoRepresentante ?? 0} onChange={(value) => handleChangeValores("descontoRepresentante", value)} /></Col>
                                <Col></Col>
                            </Row>
                            <Row>
                                <Col>Relevância (%)</Col>
                                <Col><DecimalInput disabled={edicao} value={data.valores?.relevanciaMultitec ?? 0} onChange={(value) => handleChangeValores("relevanciaMultitec", value)} /></Col>
                                <Col><DecimalInput disabled={edicao} value={data.valores?.relevanciaRepresentante ?? 0} onChange={(value) => handleChangeValores("relevanciaRepresentante", value)} /></Col>
                                <Col></Col>
                            </Row>
                            <Row>
                                <Col>Mensalidade</Col>
                                <Col><MonetaryInput disabled={edicao} value={data.valores?.mensalidadeMultitec ?? 0} onChange={(value) => handleChangeValores("mensalidadeMultitec", value)} /></Col>
                                <Col><MonetaryInput disabled={edicao} value={data.valores?.mensalidadeRepresentante ?? 0} onChange={(value) => handleChangeValores("mensalidadeRepresentante", value)} /></Col>
                                <Col><MonetaryInput disabled={edicao} value={data.valores?.mensalidadeCliente ?? 0} onChange={(value) => handleChangeValores("mensalidadeCliente", value)} /></Col>
                            </Row>
                            <Row>
                                <Col>Licenças de Uso</Col>
                                <Col><MonetaryInput value={data.valores?.licencaUso ?? 0} onChange={() => { }} disabled /></Col>
                                <Col></Col>
                                <Col><MonetaryInput value={data.valores?.cliente ?? 0} onChange={() => { }} disabled /></Col>
                            </Row>
                        </Fieldset>
                    </Col>
                </Row>
                <Row style={{ marginTop: "15px" }}>
                    <Col>
                        <Fieldset legend="SAMPalm">
                            <Row>
                                <Col md="6">
                                    <Row>
                                        <Col>Descrição</Col>
                                        <Col>Android</Col>
                                        <Col>IOs</Col>
                                    </Row>
                                    <Row>
                                        <Col>Usuarios</Col>
                                        <Col><InputNumber disabled={edicao} name="android" value={data.sampalm?.android ?? 0} onChange={handleChangeSampalm} /></Col>
                                        <Col><InputNumber disabled={edicao} name="ios" value={data.sampalm?.ios ?? 0} onChange={handleChangeSampalm} /></Col>
                                    </Row>
                                </Col>
                                <Col md="6">
                                    <Row>
                                        <Col>Usuários</Col>
                                        <Col>Android</Col>
                                        <Col>IOs</Col>
                                    </Row>
                                    <Row>
                                        <Col>1 a 5</Col>
                                        <Col>R$ 82,00</Col>
                                        <Col>R$ 164,00</Col>
                                    </Row>
                                    <Row>
                                        <Col>6 a 15</Col>
                                        <Col>R$ 74,00</Col>
                                        <Col>R$ 148,00</Col>
                                    </Row>
                                    <Row>
                                        <Col>16 a 30</Col>
                                        <Col>R$ 66,00</Col>
                                        <Col>R$ 132,00</Col>
                                    </Row>
                                    <Row>
                                        <Col>31 a 50</Col>
                                        <Col>R$ 60,00</Col>
                                        <Col>R$ 120,00</Col>
                                    </Row>
                                    <Row>
                                        <Col>51 a 100</Col>
                                        <Col>R$ 40,00</Col>
                                        <Col>R$ 80,00</Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Fieldset>
                    </Col>
                </Row>
                <Row style={{ marginTop: "15px" }}>
                    <Col>
                        <Fieldset legend="Modulos">
                            <TableContainer>
                                <Table>
                                    <thead>
                                        <tr>
                                            <Th><Checkbox disabled={edicao} checked={allSelect} onChange={selectedAll} /></Th>
                                            <Th>Modulo</Th>
                                            <Th>Lic. Uso</Th>
                                            <Th>Multitec</Th>
                                            <Th>Representante</Th>
                                            <Th>Cliente</Th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            sd11s.map(sd11 => (
                                                <tr key={sd11.sd11id}>
                                                    <Td><Checkbox disabled={edicao} checked={sd11.selected} onChange={(value) => selectModulo(sd11.sd11id)} /></Td>
                                                    <Td>{sd11.sd11sigla} - {sd11.sd11descr}</Td>
                                                    <Td> <MonetaryInput value={sd11.sd11preco} onChange={() => { }} disabled /> </Td>
                                                    <Td> <MonetaryInput value={sd11.valorMultitec} onChange={() => { }} disabled /> </Td>
                                                    <Td> <MonetaryInput value={sd11.valorRepresentante} onChange={() => { }} disabled /> </Td>
                                                    <Td> <MonetaryInput value={sd11.valorCliente} onChange={() => { }} disabled /> </Td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </Table>
                            </TableContainer>
                        </Fieldset>
                    </Col>
                </Row>

                <Row style={{ marginTop: "15px" }}>
                    {
                        sd432id == null && (
                            < Col md="2">
                                <ButtonPrimary onClick={btnSimular}>
                                    Calcular
                                </ButtonPrimary>
                            </Col>
                        )
                    }
                    {
                        sd43id != null && (
                            <Col md="2">
                                <ButtonPrimary onClick={btnSalvar}>
                                    Salvar
                                </ButtonPrimary>
                            </Col>
                        )
                    }
                </Row>
            </FormContainer>
        </AppLayout >
    )
}

const ScrollableTableContainer = styled.div`
  height: 200px; // Altura fixa
  overflow-y: auto; // Habilita a barra de rolagem vertical
  border: 1px solid #ccc; // Borda opcional para melhor visualização
  border-radius: 4px; // Borda arredondada
  box-shadow:  ${prop => prop.theme.sombras.padrao};
`;
